/**
 * ACTS company details — single source of truth for the "Bill To" block on
 * contractor invoices (and anywhere else the business identity is printed).
 *
 * Centralised so the ABN / address live in one place instead of being
 * hardcoded across InvoiceView and the backend PDF. The matching backend
 * copy lives at the top of backend/routes/invoices.js — keep the two in sync.
 *
 * ABN confirmed by Michel (75 678 243 537, 11 digits) — corrected from the
 * old hardcoded 52 670 196 184 that had been printing on invoices.
 */
export const ACTS_COMPANY = {
  name:    "ACT's Car Detailing",
  abn:     '75 678 243 537',
  address: 'Beeliar, WA 6164, Australia',
};
